module.exports = __webpack_public_path__ + "static/media/随机图像的插值图.6dfe598a.png";